import { render, staticRenderFns } from "./DetailsEventLog.vue?vue&type=template&id=0e95b247&scoped=true&"
import script from "./DetailsEventLog.vue?vue&type=script&lang=js&"
export * from "./DetailsEventLog.vue?vue&type=script&lang=js&"
import style0 from "./DetailsEventLog.vue?vue&type=style&index=0&id=0e95b247&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e95b247",
  null
  
)

export default component.exports